import { render, staticRenderFns } from "./AccessSelector.vue?vue&type=template&id=6bb370c4&"
import script from "./AccessSelector.vue?vue&type=script&lang=js&"
export * from "./AccessSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports